import React from "react";
import QRCode from "react-qr-code";
import PropTypes from "prop-types";

import { qrCodeValueGenerator } from "../../lib/qr-code-value-generator";

export const QrCodeRenderer = ({ email, secretCode }) => {
  return (
    <div className="flex items-center justify-center w-full" data-testid="qr-code">
      <div className="w-[140px] h-[140px] flex items-center justify-center">
        <QRCode 
          value={qrCodeValueGenerator(email, secretCode)} 
          size={140}
          style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        />
      </div>
    </div>
  )
};

QrCodeRenderer.propTypes = {
  email: PropTypes.string.isRequired,
  secretCode: PropTypes.string,
};
QrCodeRenderer.defaultProps = {
  secretCode: "",
};
